export const VIEWPORT_OBSERVABLE = 'segments-loader';
export const VIEWPORT_CONTAINER_ID = 'segments';
